import React from "react";
import styled from "styled-components";
import TecladoAlfanumerico from "./TecladoAlfanumerico";

/* Footer del teclado - igual que BuscadorTurnoFooter */
const TecladoFooter = styled.div`
  background-color: var(--color-latex10);
  height: 200px;
  width: 100vw;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  left: 0;
  z-index: 999999 !important;
`;

/* Curva decorativa - igual que BuscadorTurnoCurva */
const TecladoCurva = styled.div`
  background-color: var(--color-latex10);
  height: 40px;
  border-radius: 50%;
  width: 120vw;
  position: absolute;
  top: -20px;
  background-color: var(--color-latex10);
  z-index: 999999;
`;

/* Contenedor del teclado - igual que BuscadorTurnoTecladoContainer */
const TecladoContainer = styled.div`
  width: 808px;
  z-index: 999999;
  position: relative;
`;

/**
 * Componente del footer con teclado alfanumérico
 * Replica exactamente el diseño de BuscadorTurno
 */
const TecladoAlfanumericoFooter = ({
  onChange,
  onEnter,
  onDelete,
  maxLength,
  sinNumeros = true,
  enterStr = "Enter",
  modeLight = true,
}) => {
  return (
    <TecladoFooter>
      <TecladoCurva />
      <TecladoContainer>
        <TecladoAlfanumerico
          sinNumeros={sinNumeros}
          modeLight={modeLight}
          onEnter={onEnter}
          enterStr={enterStr}
          onChange={onChange}
          maxLength={maxLength}
          onDelete={onDelete}
        />
      </TecladoContainer>
    </TecladoFooter>
  );
};

export default TecladoAlfanumericoFooter;
